module.exports = __webpack_public_path__ + "static/shopify-upsell-f222f25dde359022fc08d4addf21a8f1.webm";